/* DADDY page — no frameworks, no storage APIs. Readout text is painted on canvas. */
(function () {
  "use strict";
  var NS = "http://www.w3.org/2000/svg";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var COLORS = ["#fff6dc", "#fff6dc", "#fff6dc", "#ffe9a8", "#ff3b3b", "#ffb347", "#7dff9a", "#6fc3ff", "#fff6dc"];

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function pick(a) { return a[(Math.random() * a.length) | 0]; }

  /* ---------- light banks ---------- */
  var banks = document.getElementById("banks");
  var lights = [];
  function light(x, y, w, h) {
    var c = pick(COLORS);
    var r = el("rect", { x: x, y: y, width: w, height: h, rx: 1, fill: c }, banks);
    if (Math.random() < 0.45) r.setAttribute("opacity", "0.15");
    lights.push(r);
  }
  // back-wall panels either side of the sling
  [[400, 600], [1000, 1200]].forEach(function (p) {
    el("rect", { x: p[0] - 8, y: 212, width: p[1] - p[0] + 16, height: 396, rx: 6, fill: "#0a0a0a", stroke: "#6d6d6d", "stroke-width": 2 }, banks);
    for (var y = 224; y < 596; y += 14) for (var x = p[0]; x < p[1]; x += 13) light(x, y, 8, 6);
  });
  // side walls in perspective
  [0, 1].forEach(function (side) {
    var u0 = 0.12, u1 = 0.92, v0 = 0.22, v1 = 0.74;
    function pt(u, v) {
      var x = u * 380, top = lerp(0, 170, u), bot = lerp(900, 640, u);
      if (side) x = 1600 - x;
      return [x, top + v * (bot - top)];
    }
    var c = [pt(u0, v0), pt(u1, v0), pt(u1, v1), pt(u0, v1)];
    el("polygon", { points: c.map(function (p) { return p.join(","); }).join(" "), fill: "#0a0a0a", stroke: "#6d6d6d", "stroke-width": 2 }, banks);
    for (var u = u0 + 0.03; u < u1 - 0.01; u += 0.035) {
      var s = lerp(1.6, 0.85, u);
      for (var v = v0 + 0.03; v < v1 - 0.02; v += 0.032) {
        var p = pt(u, v);
        light(p[0] - 5 * s, p[1], 9 * s, 6 * s);
      }
    }
  });
  // ceiling arc of lights
  for (var row = 0; row < 4; row++) {
    for (var a = 0; a <= 1; a += 0.012) {
      var ang = Math.PI * (0.08 + a * 0.84);
      var rx = 640 - row * 26, ry = 120 - row * 9;
      light(800 - Math.cos(ang) * rx - 4, 160 - Math.sin(ang) * ry, 7, 5);
    }
  }
  if (!reduce) {
    setInterval(function () {
      var n = Math.max(6, (lights.length * 0.03) | 0);
      for (var i = 0; i < n; i++) {
        var r = pick(lights);
        r.setAttribute("opacity", r.getAttribute("opacity") === "0.15" ? "1" : "0.15");
      }
    }, 90);
  }

  /* ---------- console keyboard + mini screen ---------- */
  var keys = document.getElementById("keys");
  for (var kr = 0; kr < 4; kr++) {
    var y = 732 + kr * 22, inset = kr * 10, x0 = 640 - inset, x1 = 960 + inset;
    for (var kx = x0; kx < x1; kx += 24) {
      el("rect", { x: kx, y: y, width: 19, height: 15, rx: 3, fill: Math.random() < 0.12 ? "#c8102e" : "#2b2b2b", stroke: "#555" }, keys);
    }
  }
  var mini = document.getElementById("miniText");
  var miniLines = [];
  for (var m = 0; m < 6; m++) miniLines.push(el("text", { x: 724, y: 628 + m * 14 }, mini));
  function glyphs(n) { var s = ""; for (var i = 0; i < n; i++) s += pick("01<>/=+#:.XO"); return s; }
  function tickMini() { miniLines.forEach(function (t) { t.textContent = glyphs(20); }); }
  tickMini();
  if (!reduce) setInterval(tickMini, 600);

  /* ---------- CRT readout ---------- */
  var cv = document.getElementById("crt");
  var ctx = cv.getContext("2d");
  var W = 900, H = 560, FONT = 30, LH = 36, PAD = 40;
  var shown = [];      // lines fully typed
  var queue = [];      // lines waiting
  var typing = "";     // current line text
  var typed = 0;
  var cursorOn = true;
  var header = "DADDY // INTERFACE";
  var stamp = "";

  function layout() {
    var cssW = cv.clientWidth || 900;
    var small = cssW < 600;
    W = small ? 470 : 900; H = small ? 600 : 560;
    FONT = small ? 24 : 28; LH = small ? 27 : 32; PAD = small ? 20 : 40;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var scale = (cssW / W) * dpr;
    cv.style.aspectRatio = W + "/" + H;
    cv.width = Math.round(W * scale); cv.height = Math.round(H * scale);
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    draw();
  }

  function wrap(line) {
    ctx.font = FONT + "px VT323, monospace";
    var max = W - PAD * 2;
    if (ctx.measureText(line).width <= max) return [line];
    var out = [], cur = "";
    line.split(" ").forEach(function (w) {
      var t = cur ? cur + " " + w : w;
      if (ctx.measureText(t).width > max && cur) { out.push(cur); cur = w; } else cur = t;
    });
    if (cur) out.push(cur);
    return out;
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    var g = ctx.createRadialGradient(W / 2, H / 2, 20, W / 2, H / 2, W * 0.7);
    g.addColorStop(0, "#04210d"); g.addColorStop(1, "#010803");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.font = FONT + "px VT323, monospace";
    ctx.textBaseline = "top";
    ctx.shadowColor = "#7dff9a"; ctx.shadowBlur = 10;
    // header bar
    ctx.fillStyle = "#7dff9a";
    ctx.fillText(header, PAD, PAD - 10);
    ctx.textAlign = "right"; ctx.fillStyle = "#ffb347"; ctx.shadowColor = "#ffb347";
    ctx.fillText(stamp, W - PAD, PAD - 10);
    ctx.textAlign = "left"; ctx.shadowColor = "#7dff9a";
    ctx.fillStyle = "rgba(125,255,154,.5)";
    ctx.fillRect(PAD, PAD + LH - 8, W - PAD * 2, 2);
    // body
    var maxRows = Math.floor((H - PAD * 2 - LH) / LH);
    var rows = shown.slice();
    if (typing || queue.length) rows.push(typing.slice(0, typed));
    rows = rows.slice(-maxRows);
    ctx.fillStyle = "#7dff9a";
    var y = PAD + LH + 4;
    rows.forEach(function (r, i) {
      ctx.fillText(r, PAD, y);
      if (i === rows.length - 1 && cursorOn) {
        var w = ctx.measureText(r).width;
        ctx.fillRect(PAD + w + 4, y + 3, FONT * 0.5, FONT * 0.8);
      }
      y += LH;
    });
    ctx.shadowBlur = 0;
  }

  var timer = null;
  function step() {
    if (!typing && queue.length) { typing = queue.shift(); typed = 0; }
    if (typing && typed < typing.length) {
      typed = reduce ? typing.length : Math.min(typing.length, typed + 2);
      window.MotherSound && MotherSound.tick();
      draw();
      timer = setTimeout(step, 14);
      return;
    }
    if (typing !== "" || queue.length) {
      shown.push(typing); typing = ""; draw();
      window.MotherSound && MotherSound.line();
      timer = setTimeout(step, reduce ? 0 : 60);
      return;
    }
    timer = null; onDone && onDone();
  }
  var onDone = null;
  function say(lines, clear, done) {
    if (timer) clearTimeout(timer);
    if (clear) shown = [];
    typing = ""; queue = [];
    lines.forEach(function (l) { wrap(l).forEach(function (w) { queue.push(w); }); });
    onDone = done || null;
    step();
  }
  setInterval(function () { cursorOn = !cursorOn; if (!timer) draw(); }, 530);

  /* ---------- queries ---------- */
  var linkEl = document.getElementById("readoutLink");
  var btnWrap = document.getElementById("queryButtons");
  var EVENTS = null;
  /* Live data: the store's Find a Club feeds (events, cruises, 979-venue directory), refreshed weekly by the store's
     automation. Falls back to the bundled snapshot if the store can't be reached. */
  var LIVE_BASE = "https://boxerandbrief.com/cdn/shop/t/65/assets/";
  var bust = "?v=" + Math.floor(Date.now() / 3600000);   // hourly cache-buster so the readout never shows a stale feed
  var VENUES = [];
  function getJSON(u) { return fetch(u).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
  function cityOf(port) { return String(port || "").split(",")[0].trim(); }
  function normalize(ev, ven) {
    VENUES = (ven.venues || []).filter(function (v) { return isFinite(v.lat) && isFinite(v.lng); });
    var byCity = {}, bySt = {};
    VENUES.forEach(function (v) {
      var k = (v.city + "|" + v.state).toLowerCase(), c = byCity[k] || (byCity[k] = { la: 0, lo: 0, n: 0 });
      c.la += v.lat; c.lo += v.lng; c.n++;
      var t = bySt[v.state.toLowerCase()] || (bySt[v.state.toLowerCase()] = { la: 0, lo: 0, n: 0 }); t.la += v.lat; t.lo += v.lng; t.n++;
    });
    function place(city, st, e) {
      var c = byCity[(city + "|" + st).toLowerCase()] || bySt[String(st).toLowerCase()];
      if (c) { e.lat = c.la / c.n; e.lng = c.lo / c.n; e.bars = (byCity[(city + "|" + st).toLowerCase()] || {}).n || 0; }
      return e;
    }
    var out = (ev.events || []).map(function (e) {
      return place(e.city, e.state, { n: e.name, cat: e.cat, city: e.city, st: e.state, d: e.start || e.est || null,
        tba: !!(e.tba || e.unv || (!e.start && e.est)), gear: e.gear });
    });
    (ev.cruises || []).forEach(function (c) {
      out.push(place(cityOf(c.port), c.portState, { n: c.name, cat: "cruise", city: cityOf(c.port), st: c.portState, d: c.start, tba: false,
        gear: { label: "Gear up for the cruise", href: "/collections/swimwear" } }));
    });
    return out;
  }
  function loadEvents() {
    if (EVENTS) return Promise.resolve(EVENTS);
    var evU = cv.getAttribute("data-events-live") || LIVE_BASE + "bb-lgbtq-events.json" + bust;
    var veU = cv.getAttribute("data-venues-live") || LIVE_BASE + "bb-lgbtq-venues.json" + bust;
    return Promise.all([getJSON(evU), getJSON(veU)]).then(function (r) { EVENTS = normalize(r[0], r[1]); return EVENTS; })
      .catch(function () {
        var src = cv.getAttribute("data-events") || "data/events.json";
        return getJSON(src).then(function (d) { EVENTS = d.events || []; return EVENTS; });
      });
  }
  function nearestClubs(la, lo, n) {
    return VENUES.map(function (v) { return { v: v, mi: miles(la, lo, v.lat, v.lng) }; })
      .sort(function (a, b) { return a.mi - b.mi; }).slice(0, n);
  }
  var MON = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  function when(e) {
    if (!e.d) return "TBA";
    var p = e.d.split("-");
    return MON[+p[1] - 1] + " " + p[0] + (e.tba ? "*" : "");
  }
  function upcoming(list) {
    var today = new Date().toISOString().slice(0, 10);
    return list.filter(function (e) { return e.d && e.d >= today; });
  }
  function miles(a, b, c, d) {
    var R = 3959, toR = Math.PI / 180, dLa = (c - a) * toR, dLo = (d - b) * toR;
    var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a * toR) * Math.cos(c * toR) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return Math.round(2 * R * Math.asin(Math.sqrt(h)));
  }
  function short(s, n) { s = s.toUpperCase(); return s.length > n ? s.slice(0, n - 1) + "." : s; }
  var ST = {"alabama":"AL","alaska":"AK","arizona":"AZ","arkansas":"AR","california":"CA","colorado":"CO","connecticut":"CT","delaware":"DE","district of columbia":"DC","florida":"FL","georgia":"GA","hawaii":"HI","idaho":"ID","illinois":"IL","indiana":"IN","iowa":"IA","kansas":"KS","kentucky":"KY","louisiana":"LA","maine":"ME","maryland":"MD","massachusetts":"MA","michigan":"MI","minnesota":"MN","mississippi":"MS","missouri":"MO","montana":"MT","nebraska":"NE","nevada":"NV","new hampshire":"NH","new jersey":"NJ","new mexico":"NM","new york":"NY","north carolina":"NC","north dakota":"ND","ohio":"OH","oklahoma":"OK","oregon":"OR","pennsylvania":"PA","rhode island":"RI","south carolina":"SC","south dakota":"SD","tennessee":"TN","texas":"TX","utah":"UT","vermont":"VT","virginia":"VA","washington":"WA","west virginia":"WV","wisconsin":"WI","wyoming":"WY","puerto rico":"PR"};
  function stAb(s) { s = String(s || ""); return ST[s.toLowerCase()] || s; }
  function mi(n) { return n < 1 ? "<1 MI" : n + " MI"; }
  function eventLines(list, withDist) {
    var out = [];
    list.forEach(function (e) {
      out.push(short(e.n, 34));
      out.push("  " + short(e.city, 18) + ", " + stAb(e.st) + (withDist ? " . " + mi(e.mi) : "") + " . " + when(e));
    });
    if (list.some(function (e) { return e.tba; })) out.push("", "* ESTIMATED DATE. CHECK BEFORE YOU BOOK.");
    return out;
  }

  var catSuggest = {};
  function suggest(types, title, link) { if (window.MotherSuggest && types && types.length) window.MotherSuggest.show(types, title, link); }

  function runNext(q) {
    say(["> " + q.label, ""].concat(q.lines), true, function () {
      loadEvents().then(function (ev) {
        var next = upcoming(ev).sort(function (a, b) { return a.d < b.d ? -1 : 1; }).slice(0, 3);
        say(["", "NEXT MISSIONS ON THE CALENDAR:", ""].concat(eventLines(next, false)), false, function () {
          showLink(q.link);
          var cat = next[0] && next[0].cat;
          suggest((cat && catSuggest[cat]) || q.suggest, "DADDY RECOMMENDS // GEAR FOR " + (next[0] ? short(next[0].n, 26) : "THE NEXT MISSION"));
        });
      }).catch(function () { say(["CALENDAR OFFLINE. TRY AGAIN SOON."], false); });
    });
  }

  function runNear(q) {
    say(["> " + q.label, "", "DADDY REQUESTS YOUR COORDINATES . . .", "YOUR BROWSER WILL ASK FIRST.", "LOCATION STAYS ON YOUR DEVICE."], true, function () {
      if (!navigator.geolocation) return denied();
      navigator.geolocation.getCurrentPosition(function (pos) {
        var la = pos.coords.latitude, lo = pos.coords.longitude;   // used here only, never sent or saved
        loadEvents().then(function (ev) {
          var list = upcoming(ev).filter(function (e) { return isFinite(e.lat); }).map(function (e) { var c = Object.assign({}, e); c.mi = miles(la, lo, e.lat, e.lng); return c; })
            .sort(function (a, b) { return a.mi - b.mi; }).slice(0, 3);
          if (!list.length) return denied();
          var lines = ["", "SECTOR LOCKED. NEAREST MISSIONS:", ""].concat(eventLines(list, true));
          var clubs = nearestClubs(la, lo, 3);
          if (clubs.length) { lines.push("", "CLUBS NEAREST YOU:");
            clubs.forEach(function (c) { lines.push("  " + short(c.v.name, 24) + " . " + mi(c.mi)); }); }
          else if (list[0].bars) lines.push("", "CLUBS LOGGED IN " + short(list[0].city, 18) + ": " + list[0].bars);
          say(lines, false, function () {
            showLink(q.link);
            suggest(catSuggest[list[0].cat] || ["Jockstraps", "Harnesses"], "DADDY RECOMMENDS // GEAR FOR " + short(list[0].n, 26),
              list[0].gear ? { text: list[0].gear.label.toUpperCase(), href: "https://boxerandbrief.com" + list[0].gear.href } : null);
          });
        }).catch(denied);
      }, denied, { enableHighAccuracy: false, timeout: 12000, maximumAge: 600000 });
    });
    function denied() {
      loadEvents().then(function (ev) {
        var next = upcoming(ev).sort(function (a, b) { return a.d < b.d ? -1 : 1; }).slice(0, 3);
        say(["", "COORDINATES WITHHELD. NO PROBLEM.", "SHOWING NATIONAL MISSIONS:", ""].concat(eventLines(next, false)), false, function () {
          showLink(q.link);
          suggest((next[0] && catSuggest[next[0].cat]) || ["Jockstraps", "Harnesses"], "DADDY RECOMMENDS // TRAVEL GEAR");
        });
      }).catch(function () { say(["", "COORDINATES WITHHELD. CALENDAR OFFLINE."], false); });
    }
  }

  function showLink(l) { if (l) { linkEl.textContent = "[ " + l.text + " ]"; linkEl.href = l.href; linkEl.hidden = false; } }

  function start(data) {
    stamp = data.updated || "";
    catSuggest = data.catSuggest || {};
    data.queries.forEach(function (q) {
      var b = document.createElement("button");
      b.type = "button"; b.textContent = q.label; b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(btnWrap.children, function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        window.MotherSound && MotherSound.press();
        linkEl.hidden = true;
        if (q.live === "near") return runNear(q);
        if (q.live === "next") return runNext(q);
        say(["> " + q.label, ""].concat(q.lines), true, function () {
          showLink(q.link);
          suggest(q.suggest, "DADDY RECOMMENDS // " + q.label);
        });
      });
      btnWrap.appendChild(b);
    });
    say(data.boot, true);
  }

  var fallback = { updated: "", boot: ["DADDY // ONLINE", "STANDING BY FOR YOUR INQUIRY_"], queries: [] };
  function boot() {
    layout();
    var src = cv.getAttribute("data-src") || "data/readout.json";
    var inline = document.getElementById("mother-data");
    if (inline) { try { start(JSON.parse(inline.textContent)); return; } catch (e) {} }
    fetch(src).then(function (r) { return r.json(); }).then(start).catch(function () { start(fallback); });
  }
  var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(layout, 120); });
  if (document.fonts && document.fonts.load) {
    Promise.race([document.fonts.load("30px VT323"), new Promise(function (r) { setTimeout(r, 1500); })]).then(boot, boot);
  } else boot();
})();
